import ModelLogo from '../models/ModelLogo'
import { LIQUIDBRAIN_ROW } from '../../data/modelGrid'

export default function ModelCard({ model }) {
  return (
    <div className="flex flex-col gap-2.5 rounded-[10px] border border-[rgba(245,245,243,.12)] px-3.5 py-4">
      <div className="flex items-center gap-2 font-mono text-[13.5px] font-medium text-[#F5F5F3]">
        <ModelLogo maker={model.maker} />
        {model.name}
        {model.soon && (
          <span className="rounded-md border border-[rgba(93,140,255,.4)] px-1.5 py-0.5 font-mono text-[9px] tracking-[0.1em] whitespace-nowrap text-[#5B8CFF] uppercase">Coming soon</span>
        )}
      </div>
      <div className="grid grid-cols-[72px_1fr] items-baseline gap-2 text-[11.5px] leading-[1.4]">
        <span className="font-mono text-[10px] tracking-[0.06em] text-[#5B8CFF] uppercase">LiquidBrain</span>
        <span className="font-medium text-[#93A9FF]">{LIQUIDBRAIN_ROW}</span>
      </div>
    </div>
  )
}
